import React from 'react'
import HRBackground from '../assets/img/slo-header-uskrs-2026-opt.png'

const heroStyle = {
    background: `url(${HRBackground})`,
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    width: '100%',
    height: '30vh',
    minHeight: '700px',
    maxHeight: '700px',
}

const HeroContent = () => {
    return (
        <div className="content-hero" style={heroStyle}></div>
    )
}

export default HeroContent